module.exports = __webpack_public_path__ + "img/strength_center_left.9d0ebece.png";